import s from "./settings-menu.css";

export default `
<div class="${s["settings-wrapper"]}">
  <div class="${s["title"]}"><h1>SETTINGS</h1></div>
  <div>
    <div>
      <input type="checkbox" id="js-sound-on" name="js-sound-on" checked />
      <label for="js-sound-on">Sound on</label>
    </div>
  </div>
  <div class="${s["title-menu-options"]}">
    <div class="${s["title-menu-option"]}" tabindex="0">
      <a id="js-settings-back-link" href="">GO BACK</a>
    </div>
  </div>
</div>`;
